/**
 * Where the customer app lives.
 *
 * The codes printed on table stickers outlive any one deployment and point at
 * the customer app, which is a *different origin* from this dashboard. It is
 * therefore configured rather than derived: the previous version rewrote this
 * app's own port to a fixed number, which is right only while both apps happen
 * to be running side by side on a developer's machine. Deployed, it produced
 * `https://dashboard.example.com:5175/t/...` — a sticker that scans to nothing.
 */

/** Port the customer app uses under `bun run dev`. */
const DEV_CUSTOMER_PORT = 5175;

/**
 * Public origin of the customer app, without a trailing slash.
 *
 * @returns The origin to encode into table and order links.
 */
export function customerOrigin(): string {
  const configured = (import.meta.env.VITE_CUSTOMER_URL as string | undefined)?.trim();
  if (configured) return configured.replace(/\/+$/, '');

  // The dev fallback keeps the hostname the dashboard was opened on, so a
  // tablet testing over the LAN still gets codes that resolve from the tablet.
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:${DEV_CUSTOMER_PORT}`;
}
